import React from 'react';
import '../../styles/layout.css';

/**
 * GridElement - Auto-arranging grid layout
 * Uses CSS Grid auto-fit to create responsive grids
 */
const GridElement = ({ element, children, isEditorMode }) => {
  const { props } = element;
  const {
    columns = { mobile: 1, tablet: 2, desktop: 3 },
    gap = 'medium',
    itemMinWidth = '250px'
  } = props || {};

  const style = {
    '--grid-min-width': itemMinWidth
  };

  return (
    <div
      className={`builder-grid ${isEditorMode ? 'builder-editor-mode' : ''}`}
      data-gap={gap}
      data-mobile-columns={columns.mobile}
      data-tablet-columns={columns.tablet}
      data-desktop-columns={columns.desktop}
      style={style}
    >
      {children}
    </div>
  );
};

export default GridElement;
